// removed by extract-text-webpack-plugin
module.exports = {"input":"input_10DU9","button":"button_8ba1i"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/container/home/style.css
 ** module id = 946
 ** module chunks = 0
 **/